/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router';
import isEmpty from 'lodash/isEmpty';

import {
    BOUNDARY_WATERS_ID,
    GRAND_TETON_ID,
    IS_ITINERARY_PERMIT_V2,
    IS_LAND_PERMIT_V2,
    IS_LOTTERY_PERMIT,
    IS_EARLY_ACCESS_PERMIT,
    IS_EXCLUDED_DAYUSE_VENUE_CALENDAR,
    OLYMPIC_ID,
} from '../constants';
import {
    permitContentSelector,
    loadPermitMapping,
} from '../../shared-components/slices/permitContent';

const shouldSkipToDetailedAvailabilityPage = (permitId, permitMapping) => {
    return (
        (IS_ITINERARY_PERMIT_V2(permitId, permitMapping) ||
            IS_LAND_PERMIT_V2(permitId, permitMapping) ||
            IS_EXCLUDED_DAYUSE_VENUE_CALENDAR(permitId) ||
            [BOUNDARY_WATERS_ID, GRAND_TETON_ID, OLYMPIC_ID].includes(permitId)) &&
        !IS_LOTTERY_PERMIT(permitId, permitMapping) &&
        !IS_EARLY_ACCESS_PERMIT(permitId, permitMapping)
    );
};

export function MobileRedirector() {
    const permitMapping = useSelector(permitContentSelector.permitMapping);
    const dispatch = useDispatch();

    const [searchParams] = useSearchParams();

    useEffect(() => {
        dispatch(loadPermitMapping());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const query = Object.fromEntries(searchParams.entries());

        const { permitId, lotteryId, geofencingSessionId } = query;
        if (permitId && !isEmpty(permitMapping)) {
            if (lotteryId) {
                // permits/234652/lottery/f4e0462a-d496-42f2-9ab5-487ac68cc7ac/registration/__234652
                let lotteryRedirectUrl = `/permits/${permitId}/lottery/${lotteryId}/registration/__${permitId}?src=mobileApp`;
                if (geofencingSessionId) {
                    lotteryRedirectUrl += `&geofencing_session_id=${geofencingSessionId}`;
                }
                window.location.assign(lotteryRedirectUrl);
            } else if (shouldSkipToDetailedAvailabilityPage(permitId, permitMapping)) {
                window.location.assign(
                    `/permits/${permitId}/registration/detailed-availability?src=mobileApp`
                );
            } else {
                window.location.assign(`/permits/${permitId}?src=mobileApp`);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permitMapping]);

    return null;
}

MobileRedirector.displayName = 'MobileRedirector';
export default MobileRedirector;
